const OBVIOUS_EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/

export function isValidCheckoutEmail(value: string): boolean {
  const email = value.trim()
  return email.length <= 254 && OBVIOUS_EMAIL_PATTERN.test(email)
}

function nzNationalNumber(value: string): string | null {
  const compact = value.trim().replace(/[\s().-]/g, '')
  if (!compact) return null

  let national = compact
  if (national.startsWith('+64')) national = `0${national.slice(3)}`
  else if (national.startsWith('64')) national = `0${national.slice(2)}`

  if (!/^0\d+$/.test(national)) return null

  // NZ geographic numbers: 03, 04, 06, 07 or 09 + seven-digit subscriber number.
  if (/^0[34679]\d{7}$/.test(national)) return national
  // NZ mobile ranges have variable subscriber lengths. This deliberately accepts
  // the common 02x national forms while rejecting obviously short/long values.
  if (/^02\d{7,9}$/.test(national)) return national
  // Common NZ freephone/service contact forms are valid customer contact numbers.
  if (/^0(?:800|508)\d{6,7}$/.test(national)) return national

  return null
}

export function isValidNzPhone(value: string): boolean {
  return nzNationalNumber(value) !== null
}

export function normalizeNzPhone(value: string): string {
  const national = nzNationalNumber(value)
  return national ? `+64${national.slice(1)}` : value.trim()
}
